import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";

@Component({
    standalone: false,
    selector: "save-cancel",
    templateUrl: "./save-cancel.component.html",
    styleUrls: ["./save-cancel.component.scss"],
})
export class SaveCancelComponent implements OnInit {
    @Input() disabled: boolean;
    @Output() onCancelClick = new EventEmitter<void>();
    @Output() onSaveClick = new EventEmitter<void>();

    constructor() {}

    ngOnInit(): void {}
}
